import { Button } from 'components/Form'
import ModalWrapper from 'components/ModalWrapper'
import React, { } from 'react'
import { I18n } from 'react-redux-i18n'
import './styles.scss'

const SyncErrorModal = (props) => {
  const { isOpen, toggle } = props

  return (
    <ModalWrapper
      id={'modalSyncError'}
      header=' '
      body={
        <div className='sync-error-wrapper'>
          <img className='icon-remove' src='img/icons/icon-warning-red.svg' alt='remove' />
          <h1>{I18n.t('dashboard_credentials-error')}</h1>
          <legend>{`${I18n.t('failed_ecommerce_installation')}`}</legend>
          <Button secondary value={`${I18n.t('dashboard_to-access')}`} onClick={toggle} />
        </div>
      }
      isOpen={isOpen}
      toggle={toggle}
      showClose={true}
    />
  )
}

export default SyncErrorModal